export const MEDEO_ALD_TYPE_VALUE = 'ALD'
export const MEDEO_ALD_TYPE_SYSTEM =
  'http://medeo.io/fhir/ValueSet/medication-request-type'
export const MEDEO_MEDICATION_REQUEST_GROUP_IDENTIFIER_NAME =
  'https://medeo.io/fhir/StructureDefinition/MedicationRequest/group-identifier-name'
